import type { ReactNode } from "react";
import { useOutletContext } from "react-router-dom";
import type { DashboardOutletContext } from "./MemberDashboard";
import { M3pProgramCard } from "./programs/M3pProgramCard";

/**
 * The My Programs content, rendered inside `MemberLayout` from the dashboard
 * the outlet context carries. The page title is the `<h1>`, the "Your
 * Programs" section carries an `<h2>` and each program card an `<h3>`.
 */
export function ProgramsScreen(): ReactNode {
  const { data } = useOutletContext<DashboardOutletContext>();
  return (
    <>
      <h1 className="text-h2 text-midnight font-serif">Healthcare Support Programs</h1>
      <section className="border-haze flex flex-col gap-6 rounded-2xl border bg-white p-6">
        <h2 className="text-body-lg text-midnight font-bold">Your Programs</h2>
        <M3pProgramCard data={data} />
      </section>
    </>
  );
}
